import { initials } from "../profiles/ProfileMenu";

/** Profile avatar / company logo: shows the uploaded image, else initials. */
export function Avatar({
  src, name, className = "h-9 w-9 rounded-lg text-xs", tone = "bg-accent/15 text-accent-strong",
}: { src?: string | null; name?: string | null; className?: string; tone?: string }) {
  const cls = `grid shrink-0 place-items-center overflow-hidden font-display font-black ${tone} ${className}`;
  if (src) return <span className={cls}><img src={src} alt="" className="h-full w-full object-cover" /></span>;
  return <span className={cls}>{initials(name)}</span>;
}
